var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatternCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1210.79 84.39"
    },
    xmlSpace: "preserve",
    viewBox: "11.76 18.3 1186.48 48.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006E54;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 897.34,
    y: 20.52,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "879.18,62.08 854.72,37.61 872.1,20.23 873.82,21.95 858.16,37.61 879.18,58.63 894.61,43.19     872.99,43.19 872.99,40.76 900.5,40.76   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M882.2,39.93l-13.43-12.26h25.69L882.2,39.93z M875.06,30.11l7.07,6.45l6.45-6.45H875.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M775.04,39.93l-13.43-12.26h25.69L775.04,39.93z M767.89,30.11l7.07,6.45l6.45-6.45H767.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "829.08,66.7 783.28,20.89 785,19.17 829.08,63.25 855.03,37.3 839.67,21.95 841.4,20.23 858.47,37.3       "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "777.14,61.54 756.19,40.59 783.41,40.59 783.41,43.03 762.07,43.03 777.14,58.09 815,20.23     816.73,21.95   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.08,
    y: 20.64,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "834.42,55.53 821.53,55.53 821.53,42.97 811.42,42.97 811.42,30.11 808.06,30.11 808.06,27.67     813.86,27.67 813.86,40.53 823.97,40.53 823.97,53.09 831.98,53.09 831.98,41.14 842.54,41.14 842.54,28.42 848.2,28.42     848.2,30.86 844.98,30.86 844.98,43.58 834.42,43.58   "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 856.44,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 859.11,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 853.65,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 799.2,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 801.87,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 796.41,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 607.36,
    y: 20.26,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "635.04,64.77 633.31,63.05 648.97,47.39 627.96,26.37 612.52,41.81 634.14,41.81 634.14,44.24      606.64,44.24 627.96,22.92 652.42,47.39    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M638.36,57.33h-25.69l12.26-12.26L638.36,57.33z M618.56,54.89h13.51l-7.07-6.45L618.56,54.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M745.53,57.33h-25.69l12.26-12.26L745.53,57.33z M725.73,54.89h13.51l-7.07-6.45L725.73,54.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "722.14,65.83 678.06,21.75 652.11,47.7 667.46,63.05 665.74,64.77 648.66,47.7 678.06,18.3      723.86,64.11    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "692.13,64.77 690.41,63.05 730,23.46 750.95,44.41 723.72,44.41 723.72,41.97 745.06,41.97      730,26.91    "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.62,
    y: 20.03,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "699.07,57.33 693.28,57.33 693.28,44.47 683.16,44.47 683.16,31.91 675.15,31.91 675.15,43.86      664.6,43.86 664.6,56.58 658.93,56.58 658.93,54.14 662.16,54.14 662.16,41.42 672.72,41.42 672.72,29.47 685.6,29.47      685.6,42.03 695.71,42.03 695.71,54.89 699.07,54.89    "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 650.7,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 648.03,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 653.49,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 707.93,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 705.26,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 710.72,
    cy: 28.33,
    r: 2.36
  })), /*#__PURE__*/React.createElement("rect", {
    x: 599.9,
    y: 20.52,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "581.74,62.08 557.28,37.61 574.66,20.23 576.39,21.95 560.72,37.61 581.74,58.63 597.17,43.19     575.55,43.19 575.55,40.76 603.06,40.76   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.77,39.93l-13.43-12.26h25.69L584.77,39.93z M577.62,30.11l7.07,6.45l6.45-6.45H577.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.6,39.93l-13.43-12.26h25.69L477.6,39.93z M470.46,30.11l7.07,6.45l6.45-6.45H470.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "531.64,66.7 485.84,20.89 487.56,19.17 531.64,63.25 557.59,37.3 542.23,21.95 543.96,20.23     561.03,37.3   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "479.7,61.54 458.75,40.59 485.97,40.59 485.97,43.03 464.63,43.03 479.7,58.09 517.56,20.23     519.29,21.95   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.64,
    y: 20.64,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "536.98,55.53 524.1,55.53 524.1,42.97 513.98,42.97 513.98,30.11 510.63,30.11 510.63,27.67     516.42,27.67 516.42,40.53 526.53,40.53 526.53,53.09 534.54,53.09 534.54,41.14 545.1,41.14 545.1,28.42 550.77,28.42     550.77,30.86 547.54,30.86 547.54,43.58 536.98,43.58   "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 559,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 561.67,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 556.21,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 501.77,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 504.44,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 498.97,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.92,
    y: 20.26,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "337.6,64.77 335.87,63.05 351.53,47.39 330.52,26.37 315.09,41.81 336.7,41.81 336.7,44.24      309.2,44.24 330.52,22.92 354.98,47.39    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.92,57.33h-25.69l12.26-12.26L340.92,57.33z M321.12,54.89h13.51l-7.07-6.45L321.12,54.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.09,57.33H422.4l12.26-12.26L448.09,57.33z M428.29,54.89h13.51l-7.07-6.45L428.29,54.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "424.7,65.83 380.62,21.75 354.67,47.7 370.02,63.05 368.3,64.77 351.22,47.7 380.62,18.3      426.42,64.11    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "394.7,64.77 392.97,63.05 432.56,23.46 453.51,44.41 426.29,44.41 426.29,41.97 447.63,41.97      432.56,26.91    "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.18,
    y: 20.03,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "401.63,57.33 395.84,57.33 395.84,44.47 385.72,44.47 385.72,31.91 377.72,31.91 377.72,43.86      367.16,43.86 367.16,56.58 361.49,56.58 361.49,54.14 364.72,54.14 364.72,41.42 375.28,41.42 375.28,29.47 388.16,29.47      388.16,42.03 398.28,42.03 398.28,54.89 401.63,54.89    "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 353.26,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 350.59,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 356.05,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 410.49,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 407.82,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 413.29,
    cy: 28.33,
    r: 2.36
  })), /*#__PURE__*/React.createElement("rect", {
    x: 302.46,
    y: 20.52,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "284.3,62.08 259.84,37.61 277.22,20.23 278.95,21.95 263.29,37.61 284.3,58.63 299.73,43.19     278.12,43.19 278.12,40.76 305.62,40.76   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.33,39.93L273.9,27.67h25.69L287.33,39.93z M280.18,30.11l7.07,6.45l6.45-6.45H280.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.16,39.93l-13.43-12.26h25.69L180.16,39.93z M173.02,30.11l7.07,6.45l6.45-6.45H173.02z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "234.2,66.7 188.4,20.89 190.12,19.17 234.2,63.25 260.15,37.3 244.8,21.95 246.52,20.23 263.6,37.3       "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "182.26,61.54 161.31,40.59 188.53,40.59 188.53,43.03 167.19,43.03 182.26,58.09 220.12,20.23     221.85,21.95   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.2,
    y: 20.64,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "239.54,55.53 226.66,55.53 226.66,42.97 216.54,42.97 216.54,30.11 213.19,30.11 213.19,27.67     218.98,27.67 218.98,40.53 229.1,40.53 229.1,53.09 237.1,53.09 237.1,41.14 247.66,41.14 247.66,28.42 253.33,28.42     253.33,30.86 250.1,30.86 250.1,43.58 239.54,43.58   "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 261.56,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 264.23,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 258.77,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 204.33,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 207,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 201.54,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.48,
    y: 20.26,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40.16,64.77 38.43,63.05 54.1,47.39 33.08,26.37 17.65,41.81 39.27,41.81 39.27,44.24 11.76,44.24      33.08,22.92 57.54,47.39    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.49,57.33H17.8l12.26-12.26L43.49,57.33z M23.68,54.89H37.2l-7.07-6.45L23.68,54.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.65,57.33h-25.69l12.26-12.26L150.65,57.33z M130.85,54.89h13.51l-7.07-6.45L130.85,54.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "127.26,65.83 83.18,21.75 57.23,47.7 72.59,63.05 70.86,64.77 53.79,47.7 83.18,18.3 128.98,64.11         "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "97.26,64.77 95.53,63.05 135.12,23.46 156.07,44.41 128.85,44.41 128.85,41.97 150.19,41.97      135.12,26.91    "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.74,
    y: 20.03,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "104.19,57.33 98.4,57.33 98.4,44.47 88.29,44.47 88.29,31.91 80.28,31.91 80.28,43.86 69.72,43.86      69.72,56.58 64.06,56.58 64.06,54.14 67.28,54.14 67.28,41.42 77.84,41.42 77.84,29.47 90.72,29.47 90.72,42.03 100.84,42.03      100.84,54.89 104.19,54.89    "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 55.82,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 53.15,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 58.61,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 113.05,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 110.38,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 115.85,
    cy: 28.33,
    r: 2.36
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 1195.08,
    y: 20.52,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1176.92,62.08 1152.46,37.61 1169.84,20.23 1171.57,21.95 1155.9,37.61 1176.92,58.63 1192.35,43.19    1170.73,43.19 1170.73,40.76 1198.24,40.76  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1179.95,39.93l-13.43-12.26h25.69L1179.95,39.93z M1172.8,30.11l7.07,6.45l6.45-6.45H1172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1072.78,39.93l-13.43-12.26h25.69L1072.78,39.93z M1065.63,30.11l7.07,6.45l6.45-6.45H1065.63z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1126.82,66.7 1081.02,20.89 1082.74,19.17 1126.82,63.25 1152.77,37.3 1137.41,21.95 1139.14,20.23    1156.21,37.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1074.88,61.54 1053.93,40.59 1081.15,40.59 1081.15,43.03 1059.81,43.03 1074.88,58.09 1112.74,20.23    1114.47,21.95  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1053.82,
    y: 20.64,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1132.16,55.53 1119.28,55.53 1119.28,42.97 1109.16,42.97 1109.16,30.11 1105.81,30.11 1105.81,27.67    1111.6,27.67 1111.6,40.53 1121.71,40.53 1121.71,53.09 1129.72,53.09 1129.72,41.14 1140.28,41.14 1140.28,28.42 1145.94,28.42    1145.94,30.86 1142.72,30.86 1142.72,43.58 1132.16,43.58  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1154.18,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1156.85,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1151.39,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1096.95,
    cy: 51.01,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1099.62,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1094.15,
    cy: 56.67,
    r: 2.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 905.1,
    y: 20.26,
    className: "st0",
    width: 2.44,
    height: 44.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "932.78,64.77 931.05,63.05 946.71,47.39 925.7,26.37 910.27,41.81 931.88,41.81 931.88,44.24     904.38,44.24 925.7,22.92 950.16,47.39   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M936.1,57.33h-25.69l12.26-12.26L936.1,57.33z M916.3,54.89h13.51l-7.07-6.45L916.3,54.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1043.27,57.33h-25.69l12.26-12.26L1043.27,57.33z M1023.47,54.89h13.51l-7.07-6.45L1023.47,54.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1019.88,65.83 975.8,21.75 949.85,47.7 965.2,63.05 963.48,64.77 946.4,47.7 975.8,18.3     1021.6,64.11   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "989.88,64.77 988.15,63.05 1027.74,23.46 1048.69,44.41 1021.47,44.41 1021.47,41.97 1042.81,41.97     1027.74,26.91   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1046.36,
    y: 20.03,
    className: "st0",
    width: 2.44,
    height: 44.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "996.81,57.33 991.02,57.33 991.02,44.47 980.9,44.47 980.9,31.91 972.9,31.91 972.9,43.86     962.34,43.86 962.34,56.58 956.67,56.58 956.67,54.14 959.9,54.14 959.9,41.42 970.46,41.42 970.46,29.47 983.34,29.47     983.34,42.03 993.46,42.03 993.46,54.89 996.81,54.89   "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 948.44,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 945.77,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 951.23,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1005.67,
    cy: 33.99,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1003,
    cy: 28.33,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1008.46,
    cy: 28.33,
    r: 2.36
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternCropped);
export default __webpack_public_path__ + "static/media/pattern-cropped.62708a28c35c1d3cbd7189ce87b57327.svg";
export { ForwardRef as ReactComponent };